import { render, staticRenderFns } from "./MessageSelect.vue?vue&type=template&id=8d78f01e"
import script from "./MessageSelect.vue?vue&type=script&lang=js"
export * from "./MessageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports